import {
  Badge,
  Button,
  Combobox,
  ComboboxContent,
  ComboboxItem,
  ComboboxList,
  ComboboxSelectAll,
  PopoverTrigger,
} from '@e2n/ui/v2';
import {
  ARBEITNEHMER_TYP,
  ArbeitnehmerTyp,
} from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitnehmerTyp';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function ArbeitnehmerTypFilter({
  value,
  onValueChange,
}: {
  value: ArbeitnehmerTyp[];
  onValueChange: (value: ArbeitnehmerTyp[]) => void;
}) {
  const { t } = useTranslation();

  const options = ARBEITNEHMER_TYP.map((typ) => ({
    value: typ,
    label: t(`domain.mitarbeiter.rotationsplan.arbeitnehmerTyp.${typ}`),
  }));

  return (
    <Combobox
      modal
      multiple
      options={options}
      value={value}
      onValueChange={(values) =>
        onValueChange(ARBEITNEHMER_TYP.filter((typ) => values.includes(typ)))
      }>
      <PopoverTrigger asChild>
        <Button type="button" variant="ghost">
          <FontAwesomeIcon className="size-4.5" icon={faFilter} />
          <Badge className="bg-neutrals-v2-200 text-labels-primary">
            {value.length}
          </Badge>
        </Button>
      </PopoverTrigger>
      <ComboboxContent
        align="end"
        className="md:w-75"
        title={t('domain.mitarbeiter.rotationsplan.filter.label')}
        doneLabel={t('actions.fertig')}>
        <ComboboxList className="pt-1">
          <ComboboxSelectAll>
            {`${t('actions.alleAuswaehlen')} (${value.length}/${options.length})`}
          </ComboboxSelectAll>
          {options.map((option) => (
            <ComboboxItem key={option.value} option={option} />
          ))}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
